/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown>, count: NonNullable<unknown> }} Import_Issue_GroupInputs */

const cs_import_issue_group = /** @type {(inputs: Import_Issue_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.path}: ${i?.count}`)
};

const en_import_issue_group = /** @type {(inputs: Import_Issue_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.path}: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{path}: {count}" |
*
* @param {Import_Issue_GroupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_issue_group = /** @type {((inputs: Import_Issue_GroupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Issue_GroupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_issue_group(inputs)
	return cs_import_issue_group(inputs)
});